import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const TeamStripeCustomerSchema = z.object({
  teamStripeCustomerId: PrimaryKeySchema,
  teamId: PrimaryKeySchema,
  externalStripeCustomerId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TeamStripeCustomer = z.infer<typeof TeamStripeCustomerSchema>;

export const TeamStripeCustomersSchema = z.array(TeamStripeCustomerSchema);

export type TeamStripeCustomers = z.infer<typeof TeamStripeCustomersSchema>;

export const ListTeamStripeCustomersQuerySchema = z.object({
  teamIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type ListTeamStripeCustomersQuery = z.infer<
  typeof ListTeamStripeCustomersQuerySchema
>;
